module.exports = __webpack_public_path__ + "img/GAME_CHILGYO1.1be06422.jpg";